/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button, Spinner , ButtonProps } from 'reactstrap';
import classnames from 'classnames';

const LoadingButton = (props: ButtonProps & { testId?: string }) => {
  const { children, loading, block, loadingText, testId = 'loading-button', ...rest } = props;
  const style = { cursor: loading ? 'initial' : 'pointer' };

  return (
    <Button data-testid={testId} style={style} {...rest} block={block}>
      {block && loading ?
        (
          <>
            <Spinner
              className={classnames({
                'position-relative': true
              })}
              size='sm'
            />
            {loadingText}
          </>
        ) : (
          <span
            className={classnames({
              invisible: loading,
              visible: !loading,
              'span-style': !block
            })}
          >
            {children}
          </span>
        )}
    </Button>
  );
};
export default LoadingButton;
